<template>
  <div id="accommodations-phone">
    <div class="card-container">
      <div class="row row-hubs">
        <div class="col-12 d-flex justify-content-center align-items-center w-100">
          <div class="lodging-header w-100">
            <div class="d-flex flex-column align-items-center text-center">
              <h2 class="merriweather-reg-20">Nos</h2>
              <h2 class="merriweather-reg-26">Nouveautés</h2>
              <p class="merriweather-light-18 mb-5">Des adresses d'exception où chaque instant est un <span class="merriweather-light-italic-18">privilège</span></p>
            </div>
            <div class="header-nav" v-if="!onlyCurrentCollection">
              <div v-for="collection in collections" :key="collection" class="header-nav-tabs">
                <div class="raleway-bold-p15 text-nowrap text-uppercase" 
                    :class="{ active: selectedCollection === collection }" 
                    @click="selectedCollection = collection; $emit('collectionSelected', collectionsSlugs[collection])" 
                    :data-value="collection">
                  {{ collection }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid position-relative pt-3">
          <div class="d-flex flex-row flex-nowrap" ref="scroller" style="overflow: scroll; overflow-y: hidden">
            <div class="card card-body border-0" v-if="lodgings"  v-for="lodging in lodgings" :key="`${selectedCollection}-${lodging.id}`" style="min-height: auto; min-width: auto; margin-right:25px; max-width: 334px;">
              <CardProductHome data-aos="fade-up" data-aos-duration="900" :lodging="lodging" :user="isUserConnected()" @connection="$emit('connection')"></CardProductHome>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lodging-redirect-btn w-100 px-4">
      <a class="hortense-btn-primary raleway-bold-p" :href="'/les-nouveautes-hortense'" target="_blank">{{ buttonText }}</a>
    </div>
  </div>
</template>

<script>
import CardProduct from '../../components/cards/CardProduct.vue';
import CardProductHome from "./CardProductHome.vue";
import AOS from "aos";


export default {
  name: 'AccommodationCard',
  props: {
    lodgings: Array,
    user: Object,
    wishlist: Object,
    onlyCurrentCollection: Boolean,
    buttonText: {
      type: String,
      default: 'Découvrir nos nouveautés'
    }
  },
  components: {CardProductHome, CardProduct },
  data() {
    return {
      lodgingsList: this.lodgings,
      lodgingsCurrentPage: 2, // starts at 2 as the first page is loaded by the parent component.
      collections: ['Romantique', 'Bien-etre', 'Famille', 'Insolite', 'City Break', 'Nature'],
      selectedCollection: null,
      collectionsSlugs: {
        'Romantique': 'sejour-romantique',
        'Bien-etre': 'sejour-spa',
        'Famille': 'sejour-en-famille',
        'Insolite': 'sejour-insolite',
        'City Break': 'city-break',
        'Nature': 'sejour-nature'
      }
    };
  },
  methods: {
    autoScroll() {
      const scroller = this.$refs.scroller;
      const step = 1; // Adjust step for speed
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0; // Reset scroll to start when it reaches the end
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth; // Recalculate in case of dynamic content
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    isUserConnected() {
      return this.user ? this.user : {};
    },
    scroll_left() {
      this.$refs.scroller.scrollLeft -= 220;
    },
    scroll_right() {
      this.$refs.scroller.scrollLeft += 220;
    }
  },
  mounted() {
    AOS.init();
    this.autoScroll();
  }
};
</script>

<style scoped>
#accommodations-phone {
    padding-top: 70px;

    .hub-img, .hub-img-zoom {
      width: 334px !important;
      height: 277px !important;
      border-radius: 15px;
    }

    .card-container {
      padding: 0 30px 0 30px !important;
    }

    .header-nav {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      row-gap: 25px;
      column-gap: 20px;
      border-radius: 10px;
      margin-bottom: 20px;

      .header-nav-tabs {
        cursor: pointer;
        color: #000000B2;

        div {
          padding: 0.5rem 1rem;
        }
      }
      .active {
        font-weight: 800;
        color: black;
        border-bottom: 2px solid #000;
      }
    }

    .lodging-redirect-btn {
      padding-top: 2rem;
    }

    @media screen and (max-width: 400px) {
      .header-nav {
        column-gap: 5px;
      }
    }
  }
</style>